import {mapProps} from 'recompose'

import compose from 'lodash/flowRight'
import * as React from 'react'

import withHook from '../hocs/withHook'
import type {BuildLineLayout, Enhancer} from '../types'
import {withContextAsProp} from '../utils/contexts'

export const BuildLineLayoutContext: React.Context<BuildLineLayout> = React.createContext(
  Object.freeze({}),
)
export const defaultBuildLineLayout: BuildLineLayout = {
  showBranch: true,
  showAgent: true,
  showDuration: true,
}

type OuterProps = BuildLineLayout & {
  children: React.ReactNode
}
type InnerProps = React.ProviderProps<BuildLineLayout>

export const BuildLineLayoutProvider = compose(
  mapProps(({children, ...value}: OuterProps) => ({
    children,
    value,
  })),
  withHook(({value}: InnerProps) => ({
    // eslint-disable-next-line react-hooks/exhaustive-deps
    value: React.useMemo(() => ({...defaultBuildLineLayout, ...value}), Object.values(value)),
  })),
)(BuildLineLayoutContext.Provider)
export const withBuildLineLayout: Enhancer<any, any> = withContextAsProp(
  BuildLineLayoutContext,
  'buildLineLayout',
)
